import { PayloadAction } from '@reduxjs/toolkit';
import { put, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';

import { authenticate, StoredUser, setPermission } from '..';
import { AuthData } from '../store/authStore';
import { extractEmployeeId } from 'src/utils/token';
import { getEmployeePermissions } from 'src/api/employeePermissions';
import { REQUIRED_PERMISSION } from 'src/constants/authConstant';

export function* loginSaga(action: PayloadAction<AuthData>): SagaIterator {
  try {
    const authData = action.payload;
    const token = authData.token;
    const userId = extractEmployeeId(token);
    const storedUser: StoredUser = {
      token,
      userId,
    };
    yield put(authenticate(storedUser));
    const permissions = yield call(getEmployeePermissions, `${userId}`, `${token}`);
    yield put(setPermission(permissions.includes(REQUIRED_PERMISSION)));
  } catch (err) {
    console.log(err);
  }
}
